/* Publish by EComposer at 2026-10-05 21:36:43*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-028hsbz1jnxd"]=  window.__ectimmers["ecom-028hsbz1jnxd"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),o=t.querySelector(".text-content.ecom-html");!o||(e&&e.addEventListener("click",()=>{o.classList.remove("ecom-text--is-mark"),o.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{o.classList.add("ecom-text--is-mark"),o.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-028hsbz1jnxd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-028hsbz1jnxd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rl7amcujbs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rl7amcujbs', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cybpdzib84c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cybpdzib84c', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jq0upbkuw6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jq0upbkuw6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3hvwadjaj1a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3hvwadjaj1a', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-r4ept0ndism').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r4ept0ndism', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3t0ec6hiynu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3t0ec6hiynu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5ue2lbm4fc9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5ue2lbm4fc9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3hbvurw8dgy').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3hbvurw8dgy', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-okylzc2lbzm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-okylzc2lbzm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a5fmnstfty').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a5fmnstfty', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-y9vsxmuog4r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y9vsxmuog4r', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-f5xoxr3x4j"]=  window.__ectimmers["ecom-f5xoxr3x4j"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const o=t.querySelector(".ecom__element--button");if(!o)return;let n=parseInt(i.settings.animation_loop_time)*1e3||6e3,s=1e3;window.__ectimmers["ecom-f5xoxr3x4j"]["xru0o4ujt"] = setInterval(function(){o.classList.add("animated"),setTimeout(function(){o.classList.remove("animated")},s)},n)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let o=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const n=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},o);try{Shopify.analytics.publish("ec_custom_events",n)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const s=e.getAttribute("href"),r=e.getAttribute("target");s&&s!=="#"&&s!=="javascript:void(0)"&&(r==="_blank"?window.open(s,"_blank"):setTimeout(function(){window.location.href=s},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-f5xoxr3x4j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f5xoxr3x4j', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}